import actionTypes from '../constants/actionTypes'

export default function leaguesReducer(state = {}, action) {

  switch(action.type) {
    case actionTypes.GET_LEAGUES:
      return Object.assign({}, state, {
        ...action.data,
        pageType: action.pageType
      })

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../app/reducers/leagues.js